import { CountViewDemo } from "./CountViewDemo";
import { MediaControlsDemo } from "./MediaControlsDemo";
import { MenuBarDemo } from "./MenuBarDemo";
import { MenuDemo } from "./MenuDemo";
import { MenuFieldDemo } from "./MenuFieldDemo";
import { ScrollBarsDemo } from "./ScrollBarsDemo";
import { ScrollViewDemo } from "./ScrollViewDemo";
import { SliderDemo } from "./SliderDemo";

export function NavigationValue() {
	return (
		<section id="navigation-value" className="demo-category">
			<h1>Navigation & Value</h1>
			<MenuDemo />
			<MenuBarDemo />
			<MenuFieldDemo />
			<SliderDemo />
			<MediaControlsDemo />
			<ScrollBarsDemo />
			<CountViewDemo />
			<ScrollViewDemo />
		</section>
	);
}
